module.exports = __webpack_public_path__ + "static/media/android-icon.dc32ad07.png";